module.exports = __webpack_public_path__ + "img/one-green-snow.c87f2b85.svg";